<script setup lang="ts">
import type { ButtonProps } from '#layers/ui/public';
import { LICENSE_CONTACT_SALES_URL } from '#layers/license/constants/urls';

const { color = 'primary' } = defineProps<{ color?: ButtonProps['color'] }>();
</script>

<template>
	<DButton
		:to="LICENSE_CONTACT_SALES_URL"
		target="_blank"
		rel="noopener noreferrer"
		size="sm"
		variant="solid"
		:color
		trailing-icon="lucide:external-link"
		:label="$t('license.contact_sales')"
	/>
</template>
